import amplitude from "amplitude-js";
import { GeneralTypes } from "@/types";

const useAnalyticsAPIProduction = site.useAnalyticsAPIEnv === "prod"; // this controls whether or not data goes to the 'real' chart

const useAnalyticsAPIStaging = true && site.useAnalyticsAPIEnv === "staging"; // data goes to test chart. should be true usually, unless you specifically DONT want logging from staging

const useAnalyticsAPIDevelopment = false && site.useAnalyticsAPIEnv === "development"; // data goes to test chart. Shold be false when submitting a PR. devs can toggle via changing true/false.

const amplitudeClient = amplitude.getInstance();
amplitudeClient.init(site["analyticsAPIKey"]);

export const setAnalyticsUserId = (id: string): void => {
  useAnalyticsAPIProduction ? amplitudeClient.setUserId(id) : amplitudeClient.setUserId("TEST_USER");
};

export const logEvent = async (eventName: string, params?: GeneralTypes.Dictionary): Promise<void> => {
  if (
    useAnalyticsAPIProduction // always log in prod
    || useAnalyticsAPIStaging // log in staging if opted in
    || useAnalyticsAPIDevelopment // log in dev if opted in
  ) {
    amplitudeClient.logEvent(eventName, { ...params });
  }
};

export const ANALYTIC_EVENTS = {
  CLAIM_DETAILS: {
    summaryTab: "claim details summary tab",
    productTab: "claim details product tab",
    pricingTab: "claim details pricing tab",
    debugTab: "claim details debug tab",
    statusHover: "claim details status hover",
  },
  MAIN_MENU: {
    hamburgerOpen: "hamburger open",
    hamburgerClose: "hamburger close",
    breadcrumb: "breadcrumb",
  },
  TEST_CLAIM_PATIENT: {
    searchForPatient: "test claim, [SEARCH FOR PATIENT] button click",
    addPatientToTestClaim: "test claim, [+ ADD PATIENT] button click",
    removePatientFromTestClaim: "test claim, removed patient via [+ ADD PATIENT] button click",
    add: "test claim, added a patient via [+ ADD] button click",
    searchCriteriaFieldFirstName: "test claim, First Name filled out",
    searchCriteriaFieldLastName: "test claim, Last Name filled out",
    searchCriteriaFieldDOB: "test claim, DOB filled out",
    searchCriteriaFieldMemberID: "test claim, Member ID filled out",
  },
  TEST_CLAIM_PHARMACY: {
    searchForPharmacy: "test claim, [SEARCH FOR PHARMACY] button click",
    addPharmacyToTestClaim: "test claim, [+ ADD PHARMACY] button click",
    removePharmacyFromTestClaim: "test claim, removed pharmacy via [+ ADD PHARMACY] button click",
    add: "test claim, added a pharmacy via [+ ADD] button click",
    searchCriteriaFieldServiceProvider: "test claim, Service Provider ID filled out",
    searchCriteriaFieldProviderName: "test claim, Provider Name filled out",
    searchCriteriaFieldStreetAddress: "test claim, Street Address filled out",
    searchCriteriaFieldZip: "test claim, Zip Code filled out",
  },
  TEST_CLAIM_DRUG: {
    searchForDrug: "test claim, [SEARCH FOR DRUG] button click",
    addDrugFromTestClaim: "test claim, [+ ADD DRUG] button click",
    add: "test claim, [+ ADD] a drug button click",
    addDrug: "test claim, [ADD DRUG(S)] button click",
    searchCriteriaDrugName: "test claim, Drug Name was entered",
    searchCriteriaNDC: "test claim, NDC was entered",
  },
  TEST_CLAIM: {
    testClaimAdjudicate: "test claim, [TEST ADJUDICATION] button click",
    serviceReferenceNumberFilled: "test claim, prescription service reference number filled out",
  },
  MANUAL_CLAIM_PATIENT: {
    searchForPatient: "manual claim, [SEARCH FOR PATIENT] button click",
    addPatientToManualClaim: "manual claim, [+ ADD PATIENT] button click",
    removePatientFromManualClaim: "manual claim, removed patient via [+ ADD PATIENT] button click",
    add: "manual claim, added a patient via [+ ADD] button click",
    searchCriteriaFieldFirstName: "manual claim, First Name filled out",
    searchCriteriaFieldLastName: "manual claim, Last Name filled out",
    searchCriteriaFieldDOB: "manual claim, DOB filled out",
    searchCriteriaFieldMemberID: "manual claim, Member ID filled out",
  },
  MANUAL_CLAIM_PHARMACY: {
    searchForPharmacy: "manual claim, [SEARCH FOR PHARMACY] button click",
    addPharmacyToManualClaim: "manual claim, [+ ADD PHARMACY] button click",
    removePharmacyFromManualClaim: "manual claim, removed pharmacy via [+ ADD PHARMACY] button click",
    add: "manual claim, added a pharmacy via [+ ADD] button click",
    searchCriteriaFieldServiceProvider: "manual claim, Service Provider ID filled out",
    searchCriteriaFieldProviderName: "manual claim, Provider Name filled out",
    searchCriteriaFieldStreetAddress: "manual claim, Street Address filled out",
    searchCriteriaFieldZip: "manual claim, Zip Code filled out",
  },
  MANUAL_CLAIM_DRUG: {
    searchForDrug: "manual claim, [SEARCH FOR DRUG] button click",
    addDrugFromManualClaim: "manual claim, [+ ADD DRUG] button click",
    add: "manual claim, [+ ADD] a drug button click",
    addDrug: "manual claim, [ADD DRUG(S)] button click",
    searchCriteriaDrugName: "manual claim, Drug Name was entered",
    searchCriteriaNDC: "manual claim, NDC was entered",
  },
  MANUAL_CLAIM: {
    manualClaimAdjudicate: "manual claim, [MANUAL ADJUDICATION] button click",
    serviceReferenceNumberFilled: "manual claim, prescription service reference number filled out",
  },
};
